import clsx from 'clsx';
import React from 'react';
import styles from './Text.module.scss';

type Props = {
    className?: string;
    Component?: React.ElementType;
    secondary?: boolean;
    strong?: boolean;
    italic?: boolean;
};

/**
 * Компонент общего назначения для отображения блока текста
 */
const Text: React.FC<Props> = ({
    className,
    Component = 'div',
    secondary,
    strong,
    italic,
    ...props
}) => {
    const composedClassName = clsx(
        styles.text,
        secondary && styles.secondary,
        strong && styles.strong,
        italic && styles.italic,
        className
    );
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Component className={composedClassName} {...props} />
    );
};

export default Text;
